import React, { useContext, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import { AuthContext } from '../context/AuthContext'
import Loading from '../component/commonUnit/Loading'
import SessionTable from '../component/session/SessionTable'
import UserProfileSession from '../component/topBar/UserProfileSession'

// role 1 = instructor, 2 = TA, 3 = anonymous guest, 4 = real, self-registered student
// account - see the role sweep in InstructorDashboardPanel.jsx etc. for the full system.
const roleLabel = (role) => {
  if (role === 1) return 'Instructor'
  if (role === 2) return 'TA'
  if (role === 3 || role === 4) return 'Student'
  return null
}

const Session = () => {
  const { currentUser } = useContext(AuthContext)
  const navigate = useNavigate()

  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return 'dark'
    const stored = window.localStorage.getItem('vzTheme') || 'dark'
    // Set synchronously during render (not in an effect) so the attribute is
    // already on <html> before first paint - avoids a dark-theme flash on mount.
    document.documentElement.setAttribute('data-vz-theme', stored)
    return stored
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-vz-theme', theme)
    window.localStorage.setItem('vzTheme', theme)
  }, [theme])

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'))
  }

  const handleHomePage = () => {
    navigate('/about')
  }

  if (!currentUser) return <Loading />

  return (
    <div className="session-page">
      <nav className="navbar">
        <div className="navbar-content">
          <div className="navbar-brand-group">
            <Link to="/about" className="navbar-brand" aria-label="VizPI home">
              <svg className="navbar-mark" viewBox="0 0 20 20" aria-hidden="true">
                <circle className="navbar-mark-pulse" cx="10" cy="4" r="2.4" />
                <circle cx="4" cy="15" r="2.4" opacity="0.55" />
                <circle cx="16" cy="15" r="2.4" opacity="0.55" />
              </svg>
              <Typography variant="h6" noWrap component="span" className="navbar-logo">
                VizPI
              </Typography>
            </Link>
            {roleLabel(currentUser?.role) && (
              <span className="navbar-role-badge">{roleLabel(currentUser.role)}</span>
            )}
          </div>

          <div className="navbar-login">
            <button
              type="button"
              className="theme-toggle"
              onClick={toggleTheme}
              aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
              {theme === 'dark' ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <circle cx="12" cy="12" r="4" />
                  <line x1="12" y1="2" x2="12" y2="4" />
                  <line x1="12" y1="20" x2="12" y2="22" />
                  <line x1="4.93" y1="4.93" x2="6.34" y2="6.34" />
                  <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
                  <line x1="2" y1="12" x2="4" y2="12" />
                  <line x1="20" y1="12" x2="22" y2="12" />
                  <line x1="4.93" y1="19.07" x2="6.34" y2="17.66" />
                  <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                </svg>
              )}
            </button>
            <button type="button" className="homepage-button" onClick={handleHomePage}>
              Homepage
            </button>
            <UserProfileSession />
          </div>
        </div>
      </nav>

      <main className="session-content">
        <div className="session-form">
          <Typography variant="h5" className="session-title">Sessions</Typography>
          <SessionTable />
        </div>
      </main>
    </div>
  )
}

export default Session
